import React from 'react';
import PropTypes from 'prop-types';

import {Flex, useMultiStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui';

import {ConfigurationPanel} from '@amblique/king-living/app/components/configuration-selector/configuration-panel';

/**
 * Desktop inline panel view — thin layout shell only.
 * Provides the Flex column container and delegates all content to ConfigurationPanel.
 */
export const DesktopPanelView = ({
  complexGalleryState,
  configProducts,
  desktopPanelInitialFocusRef,
  effectiveSelectedId,
  headerTitle,
  isLoading,
  panelHeaderInfo,
  panelMode,
  product,
  selectedProduct,
  onClose,
  onDone,
  onGalleryProductChange,
  onHeaderChange,
  onSelect,
  onSlotProductPreview,
  onViewDetails,
  setDrawerEscHandler,
}) => {
  const styles = useMultiStyleConfig('ConfigurationSelector', {});

  return (
    <Flex className="configuration-selector-panel__desktop-container" direction="column" height="100%" {...styles.desktopPanel}>
      <ConfigurationPanel
        complexGalleryState={complexGalleryState}
        configProducts={configProducts}
        desktopPanelInitialFocusRef={desktopPanelInitialFocusRef}
        effectiveSelectedId={effectiveSelectedId}
        headerTitle={headerTitle}
        isMobile={false}
        isLoading={isLoading}
        panelHeaderInfo={panelHeaderInfo}
        panelMode={panelMode}
        product={product}
        selectedProduct={selectedProduct}
        onClose={onClose}
        onDone={onDone}
        onGalleryProductChange={onGalleryProductChange}
        onHeaderChange={onHeaderChange}
        onSelect={onSelect}
        onSlotProductPreview={onSlotProductPreview}
        onViewDetails={onViewDetails}
        setDrawerEscHandler={setDrawerEscHandler}
      />
    </Flex>
  );
};

DesktopPanelView.displayName = 'DesktopPanelView';

DesktopPanelView.propTypes = {
  complexGalleryState: PropTypes.object,
  configProducts: PropTypes.array,
  desktopPanelInitialFocusRef: PropTypes.shape({current: PropTypes.any}),
  effectiveSelectedId: PropTypes.string,
  headerTitle: PropTypes.string,
  isLoading: PropTypes.bool,
  panelHeaderInfo: PropTypes.object,
  panelMode: PropTypes.string,
  product: PropTypes.object.isRequired,
  selectedProduct: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  onDone: PropTypes.func.isRequired,
  onGalleryProductChange: PropTypes.func,
  onHeaderChange: PropTypes.func,
  onSelect: PropTypes.func,
  onSlotProductPreview: PropTypes.func,
  onViewDetails: PropTypes.func,
  setDrawerEscHandler: PropTypes.func,
};
